import { useKitFoldersData } from "@/data/use-kit-folders-data";
import { getKitKnowledgeRootFolders } from "@/lib/folder";
import { Folders } from "./Folders";

type FolderListProps = {
  groupSlug: string;
  groupUuid: string;
  kitUuid: string;
  folderUuids?: string[];
};

export const FolderList: React.FC<FolderListProps> = ({
  groupUuid,
  groupSlug,
  kitUuid,
  folderUuids,
}) => {
  const { folders } = useKitFoldersData(groupUuid, kitUuid);
  const allowed = folderUuids ? new Set(folderUuids) : null;
  const rootFolders = getKitKnowledgeRootFolders(folders).filter(
    (f) => !allowed || allowed.has(f.uuid),
  );

  return (
    <Folders folders={rootFolders} groupSlug={groupSlug} kitUuid={kitUuid} />
  );
};
